import { unwrapResult } from "@reduxjs/toolkit"
import { Card, Col, message, Modal, Row, Table } from "antd"
import React, { useContext, useEffect, useState } from "react"
import { useAppDispatch } from "../../app/hooks"
import { getRiskName } from "../../models/rule"
import { ThemeContext } from "../../theme/theme"
import { getExceptionDetailAsync } from "./ExceptionMessageSlice"
import styles from "./ExceptionMessage.module.css"
import { CopyOutlined } from "@ant-design/icons"

export const ExceptionDetailModal = (props: {
  id?: any
  visible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useAppDispatch()

  const theme = useContext(ThemeContext)

  const [detail, setDetail] = useState<any>()

  // 复制内容到粘贴板
  const copy = (e: any) => {
    const range = document.createRange()
    window.getSelection()?.removeAllRanges()
    range.selectNode(e.target)
    window.getSelection()?.addRange(range)
    const successful = document.execCommand("copy")
    console.log("ddd", window.getSelection()?.addRange(range))
    if (successful) {
      message.success("复制成功")
    }
  }

  const copys = () => {
    var target: any = document.getElementById("text")?.innerText
    var input: any = document.getElementById("input")
    input.value = target
    input.select() // 选中文本
    const successful = document.execCommand("copy")
    if (successful) {
      message.success("复制成功")
    }
  }

  const getSexName = (sex: number): String => {
    switch (sex) {
      case 0:
        return "未知"
      case 1:
        return "男性"
      case 2:
        return "女性"
      case 9:
        return "未声明"
    }
    return ""
  }
  const getMedicalType = (sex: number): String => {
    switch (sex) {
      case 0:
        return "普通门诊"
      case 1:
        return "专家门诊"
      case 2:
        return "急诊"
      case 9:
        return "住院"
    }
    return ""
  }

  useEffect(() => {
    if (props.id) {
      dispatch(getExceptionDetailAsync(props.id))
        .then(unwrapResult)
        .then((d) => setDetail(d))
        .catch(() => {
          // do nothing
        })
    } else {
      setDetail(undefined)
    }
  }, [dispatch, props.id])

  const labelStyle = {
    flex: "10rem",
    style: {
      color: theme.tc3,
      fontSize: "1rem",
      textAlign: "right",
      marginBottom: 8,
    } as React.CSSProperties,
  }

  const valueStyle = {
    // flex: 1,
    style: {
      color: theme.tc1,
      fontSize: "1rem",
      marginBottom: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
    } as React.CSSProperties,
  }

  return (
    <>
      <Modal
        className={styles.model}
        width={1200}
        title='预警详情'
        footer={null}
        visible={props.visible}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
      >
        <Card
          size='small'
          title='预警违规信息'
          style={{ marginBottom: '10px' }}
        >
          <Row gutter={20}>
            <Col span={24}>
              <Row wrap={false}>
                <Col {...labelStyle}>预警规则：</Col>
                <Col {...valueStyle}>{detail?.ruleName}</Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row wrap={false}>
                <Col {...labelStyle}>上报卫健委(局)：</Col>
                <Col {...valueStyle}>{detail?.osName}</Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row wrap={false}>
                <Col {...labelStyle}>风险等级：</Col>
                <Col {...valueStyle}>{getRiskName(detail?.cautionLevel)}</Col>
              </Row>
            </Col>
            {/* <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>预警状态：</Col>
                <Col {...valueStyle}>
                  {detail?.disposeStatus === 0
                    ? "未处理"
                    : detail?.disposeStatus === 1
                    ? "未处理"
                    : detail?.disposeStatus === 2
                    ? "已处理"
                    : ""}
                </Col>
              </Row>
            </Col> */}
            <Col span={24}>
              <Row wrap={false}>
                <Col {...labelStyle}>风险ID：</Col>
                <Col {...valueStyle} onClick={copy} id='text'>
                  {detail?.dataCode}
                </Col>
                <textarea className={styles.input} id='input'></textarea>
                <Col
                  onClick={copys}
                  style={{
                    marginLeft: '4px',
                    marginTop: '2px',
                    color: theme.tc3,
                  }}
                >
                  <CopyOutlined />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>预警时间：</Col>
                <Col {...valueStyle}>{detail?.cautionTime}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>上传时间：</Col>
                <Col {...valueStyle}>{detail?.uploadTime}</Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row wrap={false}>
                <Col {...labelStyle}>风险描述：</Col>
                <Col {...valueStyle}>{detail?.cautionContent}</Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Card size='small' title='机构详情' style={{ marginBottom: '10px' }}>
          <Row gutter={20}>
            <Col span={20}>
              <Row>
                <Col {...labelStyle}>机构名称：</Col>
                <Col {...valueStyle}>{detail?.orgName}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>机构社会信用编码：</Col>
                <Col {...valueStyle}>{detail?.orgCode}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>机构属性 ：</Col>
                <Col {...valueStyle}>{detail?.orgProperty}</Col>
              </Row>
            </Col>
          </Row>
        </Card>
        {detail === {} ||
        detail?.diagnose === undefined ||
        JSON.stringify(detail?.diagnose) === '{}' ? null : (
          <Card size='small' title='诊断详情' style={{ marginBottom: '10px' }}>
            <Row gutter={20}>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>诊断ID：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.medicalNo}</Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>患者姓名：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.patientName}</Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>性别：</Col>
                  <Col {...valueStyle}>
                    {getSexName(detail?.diagnose?.patientSex)}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>科室名称：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.deptName}</Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>医生姓名：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.doctorName}</Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>门诊类型：</Col>
                  <Col {...valueStyle}>
                    {getMedicalType(detail?.diagnose?.medicalType)}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>初/复诊标识：</Col>
                  <Col {...valueStyle}>
                    {detail?.diagnose.firstVisit === 1
                      ? '复诊'
                      : detail?.diagnose.firstVisit === 0
                      ? '初诊'
                      : ''}
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>疾病识别码：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.icd10}</Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>疾病名称：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.diagnoseName}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={8}>
                <Row wrap={false}>
                  <Col {...labelStyle}>就诊时间：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.medicalTime}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={24}>
                <Row wrap={false}>
                  <Col {...labelStyle}>过敏史：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.allergyHistory}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={24}>
                <Row wrap={false}>
                  <Col {...labelStyle}>既往史：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.pastHistory}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={24}>
                <Row wrap={false}>
                  <Col {...labelStyle}>治病描述：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.diseaseDesc}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={24}>
                <Row wrap={false}>
                  <Col {...labelStyle}>治疗意见：</Col>
                  <Col {...valueStyle}>{detail?.diagnose?.operation}</Col>
                </Row>
              </Col>
            </Row>
          </Card>
        )}
        {detail === {} ||
        detail?.prescriptionS === undefined ||
        detail?.prescriptionS.length === 0 ? null : (
          <Card size='small' title='处方信息' style={{ marginBottom: '10px' }}>
            {detail?.prescriptionS?.map((p: any) => (
              <div style={{ marginBottom: '15px' }}>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <p>处方单名称：{p?.prescriptionName}</p>
                  <p style={{ marginLeft: 20 }}>
                    处方编号：{p?.prescriptionCode}
                  </p>
                  <p style={{ marginLeft: 20 }}>
                    开方时间：{p?.prescriptionTime}
                  </p>
                </div>
                <Table
                  pagination={false}
                  size='small'
                  bordered
                  dataSource={p?.drugs}
                  rowKey={(t: any) => t.id}
                  columns={[
                    {
                      title: '组号',
                      dataIndex: 'groupNo',
                      align: 'center',
                    },
                    {
                      title: '药品名称',
                      dataIndex: 'drugName',
                      align: 'center',
                    },
                    {
                      title: '通用名',
                      dataIndex: 'genericName',
                      align: 'center',
                    },
                    {
                      title: '使用天数',
                      dataIndex: 'usageDays',
                      align: 'center',
                    },
                    {
                      title: '用法',
                      dataIndex: 'drugUsage',
                      align: 'center',
                    },
                  ]}
                ></Table>
              </div>
            ))}
          </Card>
        )}
      </Modal>
    </>
  )
}
